import DispensaryPage from 'src/dispensary/home';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

DispensaryPage.layout = MainDispensaryLayout;
export default DispensaryPage;
